<template>
  <div>
    <loading
      :active.sync="loading"
      :is-full-page="fullpage"
      :height="26"
      :width="26"
    ></loading>
    <div class="container">
      <input class="input" v-model="account" placeholder="输入手机号" />
      <input
        class="input"
        v-model="password"
        placeholder="输入密码"
        type="password"
      />
      <p class="errorText" v-if="errorMessage">{{ errorMessage }}</p>
      <button class="button" @click="onLogin">登录</button>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import BaseURL from '../static/config';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'Privacy',
  components: {
    Loading,
  },
  data() {
    return {
      fullpage: true,
      loading: false,
      account: undefined,
      password: undefined,
      errorMessage: undefined,
    };
  },

  mounted() {
    const userInfoString = localStorage.getItem('bethel_userinfo');
    const dateString = localStorage.getItem('bethel_login_date');

    if (userInfoString && userInfoString.length > 0) {
      const date = Number(dateString);
      const now = new Date().getTime();
      if ((now - date) / (60 * 60 * 24 * 1000) <= 3) {
        this.$router.replace('selection');
      }
    }
  },
  methods: {
    onLogin() {
      this.errorMessage = undefined;
      if (
        !this.account ||
        !this.password ||
        this.account.length === 0 ||
        this.password.length === 0
      ) {
        this.errorMessage = '账户和密码不能为空';
      } else {
        this.loading = true;
        axios
          .post(`${BaseURL}bethel_user_login`, {
            phone_number: this.account,
            password: this.password,
          })
          .then((res) => {
            const userInfo = CryptoJS.AES.encrypt(
              JSON.stringify(res.data),
              'bethel_mobile_web_key'
            ).toString();

            console.log('--------userInfo', userInfo);
            localStorage.setItem('bethel_userinfo', userInfo);
            localStorage.setItem(
              'bethel_login_date',
              `${new Date().getTime()}`
            );
            this.$router.replace('/selection');
          })
          .catch(() => {
            this.loading = false;
            this.errorMessage =
              '登录失败，请输入正确的手机号和密码，或检查网络情况。';
          });
      }
    },
  },
};
</script>

<style scoped>
li {
  padding: 10px 0px;
  text-align: left;
}

.container {
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.input {
  height: 40px;
  width: 300px;
  border-radius: 20px;
  outline: none;
  border: #d5d5d5 1px solid;
  padding: 0 10px;
  margin-bottom: 10px;
}

.button {
  height: 40px;
  width: 320px;
  border-radius: 20px;
  outline: none;
  border: #d5d5d5 1px solid;
  margin-top: 40px;
  background-color: #49afad;
  color: white;
  font-size: 14px;
}

.input:focus {
  outline: none !important;
}

.errorText {
  color: red;
}
</style>
